<template>
  <div>
    <van-cell-group>
      <van-field v-model.trim="name" placeholder="请输入用户名" clearable />
    </van-cell-group>
    <br />
    <van-button color="#1E8DFF" block :disabled="!name" class="width-351" @click="save">保 存</van-button>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
export default {
  name: 'EditName',
  // props: {},
  data() {
    return {
      name: ''
    };
  },
  computed: {
    ...mapState(['userInfo'])
  },
  watch: {
    'userInfo.name': {
      handler(val) {
        this.name = val;
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions(['getUserInfo']),
    save() {
      let params = {
        name: this.name
      };
      if (!this.$util.isNameValid(this.name)) {
        this.$toast('姓名为2-20字的中文字符');
        return;
      }
      this.$fetch.fetchModifyUserInfo(params).then(() => {
        this.getUserInfo();
        this.$router.go(-1);
      });
    }
  }
};
</script>

<style scoped></style>
